import React, { useCallback } from "react";
import { useTheme } from "./theme";

interface TextAreaProps {
  name?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
}

export function TextArea(props: TextAreaProps) {
  const { name, value, onChange, placeholder, rows } = props;
  const theme = useTheme();

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      onChange(e.currentTarget.value);
    },
    [onChange]
  );

  return (
    <textarea
      value={value}
      placeholder={placeholder}
      rows={rows}
      onChange={handleChange}
      name={name}
      className="text-area"
      style={{ fontFamily: theme.fontFamilyBody }}
    />
  );
}
